// extracted by mini-css-extract-plugin
export default {"cls1":"FormButtons-OnBoardingButtonBlock_cls1__st3kX","cls2":"FormButtons-OnBoardingButtonBlock_cls2__JLq7g FormButtons-OnBoardingButtonBlock_cls1__st3kX"};